import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
// Initialize i18n before App
import "./i18n";
import App from "./App.tsx";

const rootEl = document.getElementById("root")!;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If pre-rendered HTML exists (has children), hydrate; otherwise mount.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}

// Signal pre-renderer that the app finished initial render.
// Wait two frames + a tick so react-helmet-async finishes flushing
// <title>, <meta>, <link rel="canonical"> into <head>.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      document.dispatchEvent(new Event("render-event"));
    }, 300);
  });
});
